import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29e4d2c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "post-detail-page" }
const _hoisted_2 = {
  key: 0,
  class: "orgInfo-wrap"
}
const _hoisted_3 = { class: "post-basic-info" }
const _hoisted_4 = { class: "df aic jcsb" }
const _hoisted_5 = { class: "df aic" }
const _hoisted_6 = { class: "post-name" }
const _hoisted_7 = {
  key: 0,
  class: "post-salary"
}
const _hoisted_8 = {
  key: 1,
  class: "post-salary"
}
const _hoisted_9 = {
  key: 2,
  class: "post-isUrgent"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode("投递简历")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("已投递")
const _hoisted_12 = { class: "df aic post-other-info" }
const _hoisted_13 = {
  key: 0,
  class: "other-info"
}
const _hoisted_14 = {
  key: 1,
  class: "other-info"
}
const _hoisted_15 = {
  key: 2,
  class: "other-info"
}
const _hoisted_16 = {
  key: 3,
  class: "other-info"
}
const _hoisted_17 = {
  key: 4,
  class: "other-info"
}
const _hoisted_18 = {
  key: 5,
  class: "other-info"
}
const _hoisted_19 = {
  key: 6,
  class: "other-info"
}
const _hoisted_20 = { class: "detail-content df jscb" }
const _hoisted_21 = { class: "detail-left" }
const _hoisted_22 = { class: "post-describe" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-head df aic" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "title-block" }),
  /*#__PURE__*/_createElementVNode("span", { class: "info-head-title" }, "职位描述")
], -1))
const _hoisted_24 = { class: "info-content has-border" }
const _hoisted_25 = { class: "tag-info" }
const _hoisted_26 = { class: "detail-jobcontent" }
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = { class: "post-address" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-head df aic" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "title-block" }),
  /*#__PURE__*/_createElementVNode("span", { class: "info-head-title" }, "工作地点")
], -1))
const _hoisted_30 = { class: "info-content" }
const _hoisted_31 = { class: "detail-right" }
const _hoisted_32 = { class: "post-hr" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-head df aic" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "title-block" }),
  /*#__PURE__*/_createElementVNode("span", { class: "info-head-title" }, "招聘HR")
], -1))
const _hoisted_34 = { class: "info-content" }
const _hoisted_35 = {
  key: 0,
  class: "info-data"
}
const _hoisted_36 = { class: "post-company" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-head df aic" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "title-block" }),
  /*#__PURE__*/_createElementVNode("span", { class: "info-head-title" }, "招聘公司")
], -1))
const _hoisted_38 = { class: "info-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_Login = _resolveComponent("Login")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_load = _resolveDirective("load")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      (_ctx.detail)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.detail.postName), 1),
                  (_ctx.detail.salaryRangeText !== '面议')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.detail.salaryRangeText) + "元/月", 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_8, "薪资面议")),
                  (_ctx.detail.isUrgent)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, "急聘"))
                    : _createCommentVNode("", true)
                ]),
                (!_ctx.detail.isDelivered)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "primary",
                      onClick: _ctx.toudi,
                      style: {"padding":"8px 40px"}
                    }, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      style: {"padding":"8px 40px"},
                      type: "primary",
                      disabled: ""
                    }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    }))
              ]),
              _createElementVNode("div", _hoisted_12, [
                (_ctx.detail.cityName)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.detail.cityName), 1))
                  : _createCommentVNode("", true),
                (_ctx.detail.conditionEducationName)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.detail.conditionEducationName), 1))
                  : _createCommentVNode("", true),
                (_ctx.detail.conditionExperienceName)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.detail.conditionExperienceName), 1))
                  : _createCommentVNode("", true),
                (_ctx.detail.isAgeLimit)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.detail.ageMin) + "-" + _toDisplayString(_ctx.detail.ageMax) + "岁 ", 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_17, "不限年龄")),
                (_ctx.detail.workTypeName)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.detail.workTypeName), 1))
                  : _createCommentVNode("", true),
                (_ctx.detail.postTypeName)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.detail.postTypeName), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.postTagTextArr, (item, index) => {
                        return (_openBlock(), _createBlock(_component_el_tag, {
                          type: "info",
                          key: index,
                          class: "tag-item"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", {
                        innerHTML: _ctx.$utils.textareaFormat(_ctx.detail.jobContent)
                      }, null, 8, _hoisted_27)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.detail.address), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.detail.recruiterName), 1),
                    (_ctx.detail.postBeginDate && _ctx.detail.postEndDate)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_35, "招聘日期：" + _toDisplayString(_ctx.$utils.dateFm(_ctx.detail.postBeginDate, "YYYY-MM-DD")) + "～" + _toDisplayString(_ctx.$utils.dateFm(_ctx.detail.postEndDate, "YYYY-MM-DD")), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _hoisted_37,
                  _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.detail.customerName), 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])), [
      [_directive_load, _ctx.isLoading]
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      title: "手机号码登录",
      width: "400px",
      center: true,
      "destroy-on-close": true,
      "before-close": _ctx.handleClose
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Login, { successCallBack: _ctx.loginSuccess }, null, 8, ["successCallBack"])
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"])
  ], 64))
}